import React from 'react';
import { I18n } from '@td/shared_utils';

const UnavailableMember = () => (
  <div>
    <h1
      className="auto-dialer-title-text text-center"
      data-testid="auto-dialer-unavailable-member-title"
    >
      <I18n scope="autodialer.call_interface.call_complete" text="member_unavailable" />
    </h1>
  </div>
);

export default UnavailableMember;
